export default __webpack_public_path__ + "static/media/facility_04_4.e9d27b00.png";